import * as React from 'react';

import { MANAGEMENT_FRAME_BREAKPOINT } from './types/management-frame-variants-enums';

interface ManagementFrameContextValue {
  breakpoint: MANAGEMENT_FRAME_BREAKPOINT;
}

export const ManagementFrameContext = React.createContext<ManagementFrameContextValue | null>(null);

export function useManagementFrameContext(partName: string): ManagementFrameContextValue {
  const context = React.use(ManagementFrameContext);

  if (!context) {
    throw new Error(`${partName} must be used within ManagementFrame.Root`);
  }

  return context;
}
